const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/devices/list.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/devices/list.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { DeviceManagementPendingState } from '@/features/device-management/components/DeviceManagementPendingState';
import { deviceListSearchSchema } from '@/features/device-management/lib/deviceManagementSearch';
import { deviceListQuery } from '@/features/device-management/services/deviceManagementQueries';
import { browserTimeZone } from '@/shared/lib/dateTime';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/devices/list')({
  validateSearch: deviceListSearchSchema,
  loaderDeps: ({
    search
  }) => search,
  loader: async ({
    cause,
    context,
    deps
  }) => {
    const query = deviceListQuery({
      q: deps.q,
      status: deps.status,
      state: 'active',
      organizationId: deps.org,
      timeZone: browserTimeZone()
    });
    const hasCachedData = context.queryClient.getQueryState(query.queryKey)?.data !== undefined;
    if (cause === 'enter' && !hasCachedData) {
      await context.queryClient.ensureInfiniteQueryData(query);
    }
  },
  shouldReload: false,
  pendingComponent: DeviceManagementPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});